import Tasks from 'APP/Tasks';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

export async function loadMore(inputPanel: InputPanel): Promise<void> {
  try {
    const response = await Tasks.search.searchUsersForMention(
      inputPanel,
      inputPanel.mention.filter || '',
      inputPanel.mention.cursor
    );

    inputPanel.mention.addMentions(response.users);
    inputPanel.mention.setCursor(response.cursor);
  } catch (error) {
    inputPanel.mention?.reset();
  }
}
